import REQUEST_CONTENTS from "../constant/REQUEST_CONTENTS"
import type { SeminarEntryFormValues } from "../types/SeminarEntryFormValues"

export const requestMessage = (seminarEntry: SeminarEntryFormValues) => {
  return seminarEntry.requestContents
    .map((it) => REQUEST_CONTENTS[it])
    .sort((a, b) => {
      return a.sort - b.sort
    })
    .map((it) => it.label.toString())
    .concat(seminarEntry.requestMessage)
    .join("\n")
}
